<div class="snackbar-content">
  <div class="icon success">
    <mat-icon style="color: #4CB848;">check_circle</mat-icon>
  </div>
  <span>{{ data.message }}</span>

  <mat-icon
    class="close-icon"
    (click)="close()"
    style="color: #8395A5; cursor: pointer;"
    >close</mat-icon
  >
</div>
